import { AxiosResponse } from "axios";
import Ajv from 'ajv'

async function schemaValidationInterceptor(response: AxiosResponse): Promise<AxiosResponse> {
    const { schema } = response.config
    if (schema) {
        const ajv = new Ajv();
        const validate = ajv.compile(schema)
        const isValid = await validate(response.data)
        if (!isValid) {
            const { errors } = validate
            return Promise.reject(errors)
        }
    }
    return response.data
}

export { schemaValidationInterceptor }